// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  banner: {
    backgroundColor: `${theme.palette.primary.main}14`,
  },
  // site-wide strip under the header
  page: {
    padding: theme.spacing(1, 2),
    textAlign: 'center',
    flex: '0 0 auto',
  },
  // inside the billing plan card
  card: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(1.5),
  },
  headline: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '16px',
  },
  body: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    marginTop: theme.spacing(0.5),
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
});

export default styles;
